import ProjectsService  from '../../api/services/ProjectsService';
import { beginApiCall, apiCallError } from './apiStatusActions';

export const LOAD_PROJECTS_SUCCESS = "LOAD_PROJECTS_SUCCESS";

function loadProjectsSuccess(projects) {
    return { type: LOAD_PROJECTS_SUCCESS, projects };
}

export function loadProjects(facilityId) {
    return function(dispatch) {
        dispatch(beginApiCall());

        return ProjectsService.getProjects(facilityId)
            .then(projects => {
                dispatch(loadProjectsSuccess(projects));
            })
            .catch(error => {
                dispatch(apiCallError(error));
                throw error;
            });
    }
}